<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-order title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="90px">
        <el-form-item label="关键字" class="kw">
          <el-input
            placeholder="请输入"
            v-model="searchData.keywordValue"
            class="input-with-select"
            size="small"
          >
            <el-select
              v-model="searchData.keywordName"
              slot="prepend"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in searchTypeOrderMall"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            style="width: 300px"
            v-model="searchData.timeSlot"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="售后状态">
          <SelectDict
            v-model="searchData.afterSaleStatus"
            width="180px"
            dictCode="order:afterSaleStatus"
          ></SelectDict>
        </el-form-item>
        <el-form-item label=" " label-width="50px">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="getList()"
            class="search-btn"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
            class="reset-btn"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      </div>
    </el-card>

    <!-- 标签页区域 -->
    <el-card class="tab-card" shadow="never">
      <div class="header-tab">
        <div class="left-tab">
          <span
            @click="searchData.activeStatus = tab.value"
            v-for="tab in orderStatus"
            :key="tab.value"
            :class="[searchData.activeStatus == tab.value ? 'select-tab' : 'tab-item']"
          >
            <el-badge
              v-if="tab.value != 0"
              :value="getStatic(tab.value)"
            >
              {{ tab.name }}
            </el-badge>
            <el-badge v-else>
              {{ tab.name }}
            </el-badge>
          </span>
        </div>

        <div class="tab-actions">
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.mall_order_list_export)"
            type="primary"
            size="small"
            icon="el-icon-download"
            @click="downloadExcel"
            class="export-btn"
          >导出</el-button>
        </div>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>订单列表</span>
      </div>
      <tp-table
        @handleSelectionChange="handleSelectionChange"
        :isCheckBox="false"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
      />
    </el-card>

    <!-- 线下支付 -->
    <el-dialog
      title="请确认首付"
      :visible.sync="dialogOfflinePay"
      width="800px"
    >
      <div class="prepay">
        <!-- 账期 -->
        <el-descriptions v-if="prePayInfo.prepayList">
          <el-descriptions-item
            v-for="(item, i) in prePayInfo.prepayList.slice(0, -2)"
            :key="i"
            :label="item.name"
            >{{ item.amount }} 元</el-descriptions-item
          >
        </el-descriptions>
        <el-divider></el-divider>
        <el-descriptions v-if="prePayInfo.prepayList" :column="1">
          <el-descriptions-item
            v-for="(item, i) in prePayInfo.prepayList.slice(-2)"
            :key="i"
            :label="item.name"
            >{{ item.amount }} 元</el-descriptions-item
          >
          <el-descriptions-item
            :labelStyle="{ fontSize: '18px', fontWeight: 'bold' }"
            :contentStyle="{ fontSize: '18px', fontWeight: 'bold' }"
            label="首付金额"
            >{{ prePayInfo.prepayAmount }} 元</el-descriptions-item
          >
        </el-descriptions>
      </div>
      <div slot="footer">
        <el-button @click="dialogOfflinePay = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitOfflinePay" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 售后状态管理 -->
    <el-dialog
      title="售后状态管理"
      :visible.sync="dialogAfterSaleStatus"
      class="after-sale-dialog"
      width="800px"
    >
      <el-form
        ref="formAfterSaleStatus"
        :model="afterSaleStatusInfo"
        label-width="130px"
      >
        <el-form-item label="订单号：">{{ afterSaleStatusInfo.orderNo }}</el-form-item>
        <el-form-item label="用户姓名：">{{ afterSaleStatusInfo.memberName }}</el-form-item>
        <el-form-item label="售后当前状态：">{{ afterSaleStatusInfo.afterSaleStatusName }}</el-form-item>
        <el-form-item label="售后状态更新：">
          <SelectDict
            v-model="afterSaleStatusInfo.afterSaleStatus"
            width="240px"
            dictCode="order:afterSaleStatus"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 20px">
        <el-button @click="dialogAfterSaleStatus = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitAfterSaleStatus" size="mini">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 取消订单 -->
    <CancelOrder
      :visible.sync="cancel.visible"
      :orderNo="cancel.orderNo"
      @refresh="handleOrderRefresh"
    />

    <div style="height: 50px"></div>
  </div>
</template>

<script>
import SelectDict from "@/views/components/select-dict.vue";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getMallOrderStaticAPI,
  getMallListAPI,
  exportOrderAPI,
  handleOrderCancelAPI,
  downloadOrderContractAPI,
  downloadPDF,
  handleCompleteAPI,
  getOfflinePayDetailAPI,
  submitOfflinePayAPI,
  hitAPI,
  handleAheadReturnAPI,
  getAfterSaleStatusAPI,
  submitAfterSaleStatusAPI,
} from "./api";
import {
  searchTypeOrderMall,
  orderStatus,
  memberType,
  dict_mall_order_type,
} from "@/enum/dict/index.js";
import { dateFormat } from "@/utils/index.js";
import CancelOrder from "./cancel-order.vue";

const columns = [
  {
    label: "订单信息",
    prop: "orderInfo",
    minWidth: "300",
    customRender(h, row) {
      return (
          <div>
            <div>订单号：{row["orderNo"]}</div>
            <div>下单时间：{row["createTime"]}</div>
            <div>订单状态：{row["statusName"]}</div>
            <div>
              订单类型：
              <el-tag v-show={row["orderType"] == 1} type="info" size="mini">商城订单</el-tag>
            </div>
            <div>售后状态：{row["afterSaleStatusName"]}</div>
          </div>
      );
    },
  },
  {
    label: "客户信息",
    prop: "member",
    minWidth: "180",
    customRender(h, row) {
      return (
        <div>
          <div>姓名：{row["member"]?.["memberName"]}</div>
          <div>手机号：{row["member"]?.["mobile"]}</div>
        </div>
      );
    },
  },
  {
    label: "设备信息",
    prop: "orderGoods",
    minWidth: "180",
    customRender(h, row) {
      return <div>{row["orderGoods"]?.["skuTitle"]}</div>;
    },
  },
  {
    label: "审核",
    prop: "reviewUser",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["reviewUser"]?.["userName"] || '-'}</p>;
    },
  },
  {
    label: "价格信息",
    prop: "rentPrice",
    minWidth: "220",
    align: "center",
    customRender(h, row) {
      return (
        <div>
          <div class="price">
            <div class="item">
              <span>总租金：</span>
              <span>{row["rentPrice"]}</span>
            </div>
            <div class="item">
              <span>总期数：</span>
              <span>{row["billPeriodNum"]}期</span>
            </div>
            <div class="item">
              <span>到期申请购买价：</span>
              <span> {row["buyoutPrice"]}</span>
            </div>
            <div class="item">
              <span>意外保：</span>
              <span> {row["insurancePrice"]}</span>
            </div>
          </div>
        </div>
      );
    },
  },
  {
    label: "订单时间",
    prop: "orderTime",
    minWidth: "250",
    customRender(h, row) {
      return (
        <div>
          <div>首期账单支付时间：{row["payTime"]}</div>
          <div>开始时间：{row["startRentDate"]}</div>
          <div>结束时间：{row["endRentDate"]}</div>
        </div>
      );
    },
  },
  {
    label: "发货信息",
    prop: "orderAddress",
    minWidth: "250",
    customRender(h, row) {
      return (
        <div>
          <div>
            收货信息：{row["orderAddress"]?.["contactName"]}{" "}
            {row["orderAddress"]?.["contactMobile"]}
          </div>
          <div>
            收货地址：{row["orderAddress"]?.["province"]}
            {row["orderAddress"]?.["city"]}
            {row["orderAddress"]?.["district"]}
            {row["orderAddress"]?.["detail"]}
          </div>
        </div>
      );
    },
  },
  {
    label: "商户信息",
    prop: "merchant",
    minWidth: "150",
    customRender(h, row) {
      return <p class="table-cell-text">{row["merchant"]?.["merchantName"] || '-'}</p>;
    },
  },
  {
    label: "订单取消",
    prop: "cancelInfo",
    minWidth: "250",
    customRender(h, row) {
      return (
          <div>
            <div v-show={Number(row["cancelReason"]) === 0}>
              <span>-</span>
            </div>
            <div v-show={Number(row["cancelReason"]) > 0}>
              <div>
                取消原因：{row["cancelReasonText"]}
              </div>
              <div>
                取消时间：{row["cancelTime"]}
              </div>
              <div>
                操作人：{row["cancelUserName"]}
              </div>
            </div>
          </div>
      );
    },
  },
  {
    label: "操作",
    minWidth: "130",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_order_list_detail)}
            style="margin-right:10px;"
            underline={false}
            type="primary"
            onClick={() => {
              let link = this.$router.resolve({
                name: `OrderDetail`,
                params: { id: row["orderNo"] },
                query: { memberId: row["member"]?.["id"] },
              });
              window.open(link.href, "_blank");
            }}
          >
            详情
          </el-link>

          <el-link
            disabled={ !this.isShowBtn(this.AUTH_BTN.mall_order_list_delivery) }
            style="margin-right:10px;"
            v-show={ this.searchData.activeStatus == 4 }
            underline={false}
            type="primary"
            onClick={() => this.handleSend(row)}
          >
            发货
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.mall_order_list_bill)}
            v-show={
              (row["status"] >= 3 &&
                row["status"] <= 9 &&
                this.searchData.activeStatus != 0) ||
              row["status"] == 91
            }
            style="margin-right:10px;"
            underline={false}
            type="primary"
            onClick={() => {
              let link = this.$router.resolve({
                name: `OrderBill`,
                params: { id: row["orderNo"] },
              });
              window.open(link.href, "_blank");
            }}
          >
            账单
          </el-link>

          <el-link
              disabled={ !this.isShowBtn(this.AUTH_BTN.mall_order_list_offline_pay) }
              style="margin-right:10px;"
              v-show={ this.searchData.activeStatus == 2 }
              underline={false}
              type="primary"
              onClick={() => this.handleOfflinePay(row)}
          >
            线下支付
          </el-link>

          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.mall_order_list_contract)}
              style="margin-right:10px;"
              v-show={
                  (row["status"] >= 4 &&
                      row["status"] <= 9 &&
                      this.searchData.activeStatus != 0) ||
                  row["status"] == 91
              }
              underline={false}
              type="primary"
              onClick={() => this.downloadOrderContract(row['orderNo'])}
          >
            合同下载
          </el-link>

          <el-link
            disabled={ !this.isShowBtn(this.AUTH_BTN.mall_order_list_cancel) }
            style="margin-right:10px;"
            v-show={ 
              !this.isShowBtn(this.AUTH_BTN.order_list_cancel_high) &&
              row["status"] <= 2 &&
              this.searchData.activeStatus != 0 
            }
            underline={false}
            type="primary"
            onClick={() => this.handleOrderCancel(row["orderNo"])}
          >
            取消
          </el-link>

          <el-link
            disabled={ !this.isShowBtn(this.AUTH_BTN.mall_order_list_cancel_high) }
            style="margin-right:10px;"
            v-show={
              this.isShowBtn(this.AUTH_BTN.mall_order_list_cancel_high) &&
              this.searchData.activeStatus < 8 &&
              row["status"] < 91
            }
            underline={false}
            type="primary"
            onClick={() => this.handleOrderCancel(row["orderNo"])}
          >
            取消2
          </el-link>

          <el-link
              disabled={ !this.isShowBtn(this.AUTH_BTN.mall_order_list_after_sale_status) }
              style="margin-right:10px;"
              v-show={this.searchData.activeStatus == 7}
              underline={false}
              type="primary"
              onClick={() => this.handleAfterSaleStatus(row["orderNo"])}
          >
            售后状态
          </el-link>

          <el-link
              disabled={ !this.isShowBtn(this.AUTH_BTN.mall_order_list_ahead_return) }
              style="margin-right:10px;"
              v-show={row["status"] == 6 || row["status"] == 7}
              underline={false}
              type="primary"
              onClick={() => this.handleAheadReturn(row)}
          >
            提前归还
          </el-link>

          <el-link
            disabled={
              !this.isShowBtn(this.AUTH_BTN.mall_order_list_complete)
            }
            style="margin-right:10px;"
            v-show={this.searchData.activeStatus == 8}
            underline={false}
            type="primary"
            onClick={() => this.handleComplete(row)}
          >
            完成
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "MallOrderList",
  mixins: [authBtnMixin],
  components: { 
    SelectDict, 
    CancelOrder,
  },
  data() {
    return {
      dialogOfflinePay: false,
      dialogVisible: false,
      dialogAfterSaleStatus: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordName: "",
        keywordValue: "",
        timeSlot: [],
        leftCreateDate: "",
        rightCreateDate: "",
        activeStatus: "0",
        memberType: "",
        storeName: "",
        afterSaleStatus: "",
      },
      // 字典
      searchTypeOrderMall,
      orderStatus,
      dict_mall_order_type,
      // 已勾选
      tableSelected: [],
      staticData: {},
      memberType,
      // 其他
      isFirstEnter: true,
      // 首付明细
      prePayInfo: {},
      prePayOrderNo: "",
      comboList: [],
      afterSaleStatusInfo: {
        orderNo: "",
        memberName: "",
        afterSaleStatus: "",
        afterSaleStatusName: "",
      },
      cancel: {
        visible: false,
        orderNo: null,
      },
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  created() {
    this.isFirstEnter = true;
  },

  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    this.getList();
  },
  mounted() {
    window["getBpageList"] = () => {
      this.getList();
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
    "searchData.activeStatus": {
      // immediate: true,
      handler(newV, oldV) {
        this.getList();
      },
    },
  },
  methods: {
    async getList() {
      const {
        timeSlot,
        keywordName,
        keywordValue,
        activeStatus,
        memberType,
        storeName,
        afterSaleStatus,
      } = this.searchData;
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        memberType,
        storeName,
        afterSaleStatus,
      };
      if (activeStatus != 0) params.status = activeStatus - 0;
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0];
        params.rightCreateDate = timeSlot[1];
      }
      if (keywordName) params[keywordName] = keywordValue;
      const res = await getMallListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
      this.getOrderStatic();
    },
    handleSelectionChange(val) {
      this.tableSelected = val;
    },
    reset() {
      let act = false;
      if (this.searchData.activeStatus == "0") {
        act = true;
      }
      Object.assign(this._data.searchData, this.$options.data().searchData);
      if (act) {
        this.getList();
      }
    },
    handleOrderRefresh() {
      this.getList();
    },
    // 取消订单
    async handleOrderCancel(orderNo) {
      this.$set(this, "cancel", {
        visible: true,
        orderNo,
      });
    },
    // 下载合同
    downloadOrderContract(orderNo) {
      this.$confirm("此操作将下载该订单合同, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          downloadOrderContractAPI(orderNo).then((res) => {
            const name = `${orderNo}_${dateFormat()}.pdf`;
            downloadPDF(res.downloadUrl, name);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    async getOrderStatic() {
      this.staticData = await getMallOrderStaticAPI();
    },
    getStatic(value) {
      const { staticData } = this;
      let num = 0;
      switch (value) {
        case "1":
          num = staticData.inReviewNum || 0;
          break;
        case "2":
          num = staticData.waitPayNum || 0;
          break;
        case "3":
          num = staticData.waitContractNum || 0;
          break;
        case "4":
          num = staticData.waitDeliveryNum || 0;
          break;
        case "5":
          num = staticData.waitReceiveNum || 0;
          break;
        case "6":
          num = staticData.inRentNum || 0;
          break;
        case "7":
          num = staticData.inOverdueNum || 0;
          break;
        case "8":
          num = staticData.waitBuyoutNum || 0;
          break;
        case "9":
          num = staticData.waitReturnNum || 0;
          break;
        case "91":
          num = staticData.completeNum || 0;
          break;
        case "92":
          num = staticData.cancelNum || 0;
          break;
        case "93":
          num = staticData.refuseNum || 0;
          break;

        default:
          break;
      }
      return num;
    },
    // 导出
    downloadExcel() {
      const {
        timeSlot,
        keywordName,
        keywordValue,
        activeStatus,
        memberType,
        storeName,
        afterSaleStatus,
      } = this.searchData;
      let params = {
        memberType,
        storeName,
        afterSaleStatus,
      };
      if (activeStatus != 0) params.status = activeStatus - 0;
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0];
        params.rightCreateDate = timeSlot[1];
      }
      if (keywordName) params[keywordName] = keywordValue;
      exportOrderAPI(params);
    },
    // 发货按钮
    async handleSend({ deliveryType, orderNo }) {
      const { rosterLevelList } = await hitAPI(orderNo);
      localStorage.setItem("deliveryType", deliveryType);
      localStorage.setItem("rosterLevelList", JSON.stringify(rosterLevelList));
      let link = this.$router.resolve({
        name: `OrderDelivery`,
        params: { id: orderNo },
      });
      window.open(link.href, "_blank");
    },
    // 完成
    handleComplete({ orderNo }) {
      this.$confirm("确认要操作已完成吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          handleCompleteAPI({ orderNo }).then(() => {
            this.$message.success("操作成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 提前归还
    handleAheadReturn({ orderNo }) {
      this.$confirm("确认要操作提前完成吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          handleAheadReturnAPI({ orderNo }).then(() => {
            this.$message.success("操作成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 线下支付
    handleOfflinePay({ orderNo }) {
      this.prePayOrderNo = orderNo;
      getOfflinePayDetailAPI(orderNo).then((res) => {
        this.prePayInfo = res;
        this.dialogOfflinePay = true;
      });
    },
    // 确认首付
    submitOfflinePay() {
      submitOfflinePayAPI(this.prePayOrderNo).then(() => {
        this.$message.success("首付成功");
        this.getList();
        this.dialogOfflinePay = false;
      });
    },
    handleAfterSaleStatus(orderNo) {
      getAfterSaleStatusAPI(orderNo).then((res) => {
        this.afterSaleStatusInfo = res;
        this.dialogAfterSaleStatus = true;
      });
    },
    submitAfterSaleStatus() {
      let data = {
        orderNo: this.afterSaleStatusInfo.orderNo,
        afterSaleStatus: this.afterSaleStatusInfo.afterSaleStatus,
      };
      submitAfterSaleStatusAPI(data).then(() => {
        this.$message.success("操作成功");
        this.getList();
        this.dialogAfterSaleStatus = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 14px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input,
        .el-select {
          width: 180px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
        
        .el-select {
          .el-input__inner {
            border-radius: 10px;
          }
        }
        
        .el-date-editor {
          width: 300px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-range-separator {
            padding: 0 10px;
            color: #606266;
            font-weight: 500;
          }
          
          .el-range-input {
            width: 35%;
            font-size: 13px;
          }
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            border: 1.5px solid #E4E7ED;
            background: #fafbfc;
          }
          
          &:hover .el-input__inner {
            border-color: #C0C4CC;
            background: #ffffff;
          }

          &.is-active,
          &:focus-within {
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            border-radius: 10px;
            
            .el-input__inner {
              background: #ffffff;
            }
          }
        }
      }
      
      .kw {
        .el-select .el-input {
          width: 118px;
        }
        .el-select {
          width: 120px;
        }
        .input-with-select {
          vertical-align: middle;
          width: 320px;
          
          .el-input-group__prepend {
            background-color: #fff;
            border-radius: 10px 0 0 10px;
          }
          
          .el-input__inner {
            border-radius: 0 10px 10px 0;
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 标签页卡片样式
.tab-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  ::v-deep .el-card__body {
    padding: 16px 24px;
  }

  .header-tab {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .left-tab {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      
      .tab-item,
      .select-tab {
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 8px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        font-size: 14px;
        font-weight: 500;
        color: #606266;
        position: relative;
        
        &:hover {
          background: #f5f7fa;
          color: #409EFF;
        }
      }
      
      .select-tab {
        color: #409EFF;
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
        font-weight: 600;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          height: 3px;
          background: linear-gradient(90deg, #409EFF 0%, #66b1ff 100%);
          border-radius: 2px 2px 0 0;
        }
      }
      
      ::v-deep .el-badge {
        .el-badge__content.is-fixed {
          position: absolute !important;
          top: -3px !important;
          right: 4px !important;
          transform: translateY(-50%) translateX(100%) !important;
          border-radius: 10px;
          border: 2px solid #ffffff;
          font-weight: 600;
          font-size: 11px;
          min-width: 20px;
          height: 20px;
          line-height: 16px;
        }
      }
    }
    
    .tab-actions {
      display: flex;
      gap: 10px;
      
      .export-btn {
        border-radius: 10px;
        padding: 8px 20px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }
    }

    .table-cell-text {
      margin: 0;
      color: #606266;
      font-size: 13px;
      line-height: 1.8;
      font-weight: 400;
    }

    .price {
      .item {
        min-width: 200px;
        display: flex;
        margin-bottom: 8px;
        span {
          &:first-child {
            min-width: 100px;
            text-align: right;
            color: #606266;
            font-size: 13px;
          }
          &:last-child {
            min-width: 100px;
            text-align: left;
            color: #303133;
            font-weight: 600;
            font-size: 13px;
          }
        }
      }
    }
    
    // 表格内容区域样式
    td {
      div {
        font-size: 13px;
        line-height: 1.8;
        color: #606266;
        margin-bottom: 4px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// 操作链接样式
::v-deep .el-link {
  margin-right: 10px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover:not(.is-disabled) {
    transform: translateY(-1px);
  }
  
  &.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// 对话框样式
::v-deep .el-dialog {
  border-radius: 12px;
  
  .el-dialog__header {
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 2px solid #f0f2f5;
    
    .el-dialog__title {
      font-size: 18px;
      font-weight: 700;
      color: #1a1e25;
    }
  }
  
  .el-dialog__body {
    padding: 24px;
  }
  
  .el-dialog__footer {
    padding: 16px 24px;
    background: #fafbfc;
    border-top: 1px solid #f0f2f5;
  }
}

.prepay {
  .list {
    .item {
      margin: 5px 0;
    }
  }
}

.after-sale-dialog {
  .el-form-item {
    margin-bottom: 0;
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card .header-search ::v-deep .el-form {
    .el-form-item {
      margin-right: 12px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .tab-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .tab-card .header-tab {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .left-tab {
      width: 100%;
      overflow-x: auto;
    }
  }
}
</style>
